let autoSlash = document.querySelectorAll('.autoslash');

if(autoSlash && autoSlash.length > 0) {

    for (var i = 0; i < autoSlash.length; i++) {

        // autoSlash[i].addEventListener('keydown', (e) => {
        //     let value = e.target.value;
        //     let length = value.length;
        //     let lastLetter = value.substr(length-1, 1);
        //
        //     // if(e.key == '/') e.preventDefault();
        //
        //     if((length === 3 || length === 5) && lastLetter != '/') {
        //         e.target.value = value + '/';
        //     }
        // });

        autoSlash[i].addEventListener('keyup', (e) => {

            let value = e.target.value;
            let length = value.length;
            let lastLetter = value.substr(length-1, 1);

            if((length === 2 || length === 5) && !isNaN(e.key)) {
                e.target.value = value + '/';
            }

            //Avoid too much slash
            value = e.target.value;
            length = value.length;
            lastLetter = value.substr(length-1, 1);
            if(e.key == '/' && lastLetter == '/') {
                e.target.value = value.substring(0, length - 1);
            }
        });

    }
}
